const Nabox = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        height='35'
        width='35'
        viewBox='0 0 200.17 228.32'
        fill='#fff'
        id='nabox'
    >
        <title>Nabox</title>
        <g id='图层_2' data-name='图层 2'>
            <g id='图层_1-2' data-name='图层 1'>
                <polygon
                    className='cls-1'
                    points='0 64.12 0 170.46 30.79 188.21 30.79 112.14 61.47 129.86 61.47 205.88 92.27 223.63 92.27 117.28 0 64.12'
                />
                <path
                    className='cls-1'
                    d='M69.94,54.39l30.85-18.08,38.33,22.43-30.83,18ZM100.83,0l-93,54.41,100.29,58.8,0,115.11,30.42-17.72V94.15l30.74-18V192.5l30.87-18.17V58.11Z'
                />
            </g>
        </g>
    </svg>
);

export default Nabox;
